<section class="featured-services-area pt-100">
    <div class="container">
        <!-- <div class="section-title" *ngFor="let sectionTitleContent of sectionTitle;">
            <h2>{{sectionTitleContent.title}}</h2>
            <p>{{sectionTitleContent.paragraphText}}</p>
        </div> -->

        <div class="row">
            <div
                class="col-lg-4 col-md-6 col-sm-6"
                *ngFor="
                    let featuredServicesContent of singleFeaturedServicesBox
                "
            >
                <div class="single-featured-services-box">
                    <div class="{{ featuredServicesContent.class }}">
                        <h3>{{ featuredServicesContent.title }}</h3>
                    </div>
                    <ul
                        style="
                            margin: 30px 15px 0 15px;
                            color: var(--blackColor);
                        "
                    >
                        <li style="margin: 20px 0 0 0">
                            {{ featuredServicesContent.paragraphText }}
                        </li>
                        <li style="margin: 20px 0 0 0">
                            {{ featuredServicesContent.paragraphText1 }}
                        </li>
                        <li style="margin: 20px 0 0 0">
                            {{ featuredServicesContent.paragraphText2 }}
                        </li>
                        <li
                            *ngIf="featuredServicesContent.paragraphText3 != ''"
                            style="margin: 20px 0 0 0"
                        >
                            {{ featuredServicesContent.paragraphText3 }}
                        </li>
                    </ul>
                    <!-- <a routerLink="/{{featuredServicesContent.link}}" class="read-more-btn"><i class="{{featuredServicesContent.linkIcon}}"></i>{{featuredServicesContent.linkText}}</a> -->
                    <!-- <div class="icon">
                        <i class="{{featuredServicesContent.icon}}"></i>
                    </div> -->
                </div>
            </div>
        </div>
    </div>
</section>
